// extracted by mini-css-extract-plugin
export default {"contentContainer":"g_uyV e2H7L","rulesText":"gPKmE","heading":"w364z","wrapperList":"flYv1","listTitle":"LuiND"};